import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import {
  btnColor,
  btnDisabledFlg,
  mainBlueColor,
  workingBudgetVendor
} from '../../GlobalState';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import _ from 'lodash';
import { VenderSelectModal } from './VenderSelectModal';

type TProps = {
  onSubmit: any;
};

/**
 * ボタンエリア
 * @constructor
 */
export const BottomButton: React.FC<TProps> = (props: TProps) => {
  const { onSubmit } = props;

  const [buttonColor] = useRecoilState(btnColor);
  const [disabledFlg] = useRecoilState(btnDisabledFlg);
  const classes = useStyles({ buttonColor: buttonColor });

  return (
    <div className={classes.container}>
      <div className={classes.right}>
        {/* NOTE: 第二フェーズで実装予定 */}
        {/* <Button
          className={classes.grayBtn}
          variant="contained"
          color="primary"
        >
          商品発注書を作成
        </Button>
        <Button
          className={classes.grayBtn}
          variant="contained"
          color="primary"
        >
          外注発注書を作成
        </Button>
        <Button
          className={classes.grayBtn}
          variant="contained"
          color="primary"
        >
          プレビュー
        </Button> */}
        <Button
          style={{ backgroundColor: buttonColor }}
          disabled={disabledFlg}
          variant='contained'
          color='primary'
          onClick={onSubmit}
        >
          保存
        </Button>
      </div>
    </div>
  );
};

type TStyleProps = {
  buttonColor: string;
};

const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      width: '100%',
      padding: 10
    },
    right: {
      display: 'flex',
      width: '100%',
      gap: 20,
      justifyContent: 'flex-end'
    }
  })
);
